var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({staticClass:"my-2",attrs:{"label":_vm.label,"close":_vm.close,"color":_vm.color,"text-color":_vm.textColor,"dark":_vm.dark,"close-icon":_vm.closeIcon}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }